import React from 'react';
import ReportGenerator from '../components/ReportGenerator';

const Reports = () => (
  <div className="container mx-auto p-4">
    <h1 className="text-2xl font-bold mb-4">Reports</h1>
    <ReportGenerator />
  </div>
);

export default Reports;
